import { Icon } from "@iconify/react";

const clampNumber = (value, min, max) =>
  Math.min(max, Math.max(min, Number(value)));

const Stepper = ({ steps = 3, activedStep = 1, className = "" }) => {
  const safeSteps = Math.max(1, Number(steps) || 1);
  const safeActivedStep = clampNumber(activedStep, 0, safeSteps);
  // Progress is "between steps":
  // - step 1 => 0%
  // - step N => 100%
  // - step 0 (not started) => 0%
  const denominator = Math.max(1, safeSteps - 1);
  const normalizedStep = Math.max(0, safeActivedStep - 1);
  const activedWidth = (normalizedStep / denominator) * 100;

  return (
    <div className={`w-full ${className}`}>
      <div className="w-full bg-[#E5E7EB] mb-[22px] h-2 rounded-full relative overflow-hidden">
        <div
          className="absolute inset-0 bg-primary transition-[width,opacity] duration-500 ease-out"
          style={{
            width: `${activedWidth}%`,
            opacity: safeActivedStep === 0 ? 0 : 1,
          }}
        ></div>
      </div>
      <div className="w-full flex flex-row items-center justify-between">
        {Array.from({ length: steps }).map((_, index) => (
          <div
            key={index}
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ease-out ${
              safeActivedStep === index + 1
                ? "bg-primary text-white"
                : safeActivedStep > index + 1
                ? "bg-[#00C950] text-white"
                : "bg-[#E5E7EB] text-[#6A7282]"
            }`}
          >
            {safeActivedStep > index + 1 ? (
              <Icon
                icon="mdi:checkbox-marked-circle-outline"
                className="w-5 h-5"
              />
            ) : (
              index + 1
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
